import { createFileRoute } from "@tanstack/react-router";
import { ReportsLibrary, reportsHead } from "@/components/ReportsLibrary";
import { listPublishedReports } from "@/lib/reports.functions";

export const Route = createFileRoute("/research/")({
  // SSR the report list so crawlers (and no-JS clients) get the full HTML
  // instead of a "Loading…" placeholder. The query cache is primed with the
  // same queryKey the ReportsLibrary component reads via useQuery.
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData({
      queryKey: ["public-reports"],
      queryFn: () => listPublishedReports(),
    });
    return null;
  },
  head: () => reportsHead("en", { path: "/research", trPath: "/raporlar", enPath: "/research" }),
  component: () => <ReportsLibrary lang="en" />,
});
